/* Colheita: frete grátis por região, calculado pelo CEP.
   Valores mínimos (em reais) por região. Mantenha igual às regras de frete do Shopify.
   O valor do carrinho já vem com cupons descontados (igual ao checkout). */
(function () {
  var FRETE_REGIOES = {
    sudeste: { nome: 'RJ e Sudeste', min: 200 },
    sulco: { nome: 'Sul e Centro-Oeste', min: 300 },
    nne: { nome: 'Norte e Nordeste', min: 350 }
  };
  var CHAVE = 'colheita_cep';

  function limpar(cep) { return String(cep || '').replace(/\D/g, '').slice(0, 8); }

  function regiaoDoCep(cep) {
    cep = limpar(cep);
    if (cep.length !== 8) return null;
    var p = parseInt(cep.slice(0, 2), 10);
    if (p <= 39) return FRETE_REGIOES.sudeste;          // SP, RJ, ES, MG
    if (p >= 80) return FRETE_REGIOES.sulco;            // PR, SC, RS
    if (p >= 70 && p <= 76) return FRETE_REGIOES.sulco; // DF, GO
    if (p === 78 || p === 79) return FRETE_REGIOES.sulco; // MT, MS
    return FRETE_REGIOES.nne;                            // Nordeste, Norte e TO
  }

  function lerCep() { try { return localStorage.getItem(CHAVE) || ''; } catch (e) { return ''; } }
  function salvarCep(cep) { try { localStorage.setItem(CHAVE, limpar(cep)); } catch (e) {} }
  function formatarCep(cep) { cep = limpar(cep); return cep.length === 8 ? cep.slice(0, 5) + '-' + cep.slice(5) : cep; }
  function reais(v) { return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }

  function atualizar(bar) {
    var total = (parseInt(bar.getAttribute('data-cart-total'), 10) || 0) / 100;
    var cep = lerCep() || bar.getAttribute('data-customer-cep') || '';
    var regiao = regiaoDoCep(cep);
    var r = regiao || FRETE_REGIOES.sudeste;
    var falta = Math.max(0, r.min - total);
    var pct = Math.min(100, Math.round((total / r.min) * 100));

    var texto = bar.querySelector('.js-frete-text');
    var fill = bar.querySelector('.js-frete-fill');
    var rotulo = bar.querySelector('.js-frete-regiao');
    var toggle = bar.querySelector('.js-frete-cep-toggle');
    var chave = [total, cep, r.min].join('|');
    if (bar.getAttribute('data-frete-ok') === chave) return; // já atualizada, evita laço com o observer
    bar.setAttribute('data-frete-ok', chave);
    if (texto) {
      if (total <= 0) texto.innerHTML = 'Frete grátis pra ' + r.nome + ' a partir de <strong>' + reais(r.min) + '</strong>';
      else if (falta > 0) texto.innerHTML = 'Faltam <strong>' + reais(falta) + '</strong> pro frete grátis';
      else texto.innerHTML = 'Oba! Você ganhou frete grátis';
    }
    if (fill) fill.style.width = pct + '%';
    if (rotulo) rotulo.textContent = regiao ? 'CEP ' + formatarCep(cep) + ' (' + r.nome + ', a partir de ' + reais(r.min) + ').' : 'Valor pra ' + FRETE_REGIOES.sudeste.nome + '.';
    if (toggle) toggle.textContent = regiao ? 'Trocar CEP' : 'Calcular pelo meu CEP';
  }

  // Calculadora de frete da página do produto (bloco "Calculo de Frete"):
  // corrige o aviso pela região do CEP digitado e guarda o CEP pro carrinho.
  function atualizarAvisosProduto() {
    var avisos = document.querySelectorAll('.frete-estimado__aviso');
    for (var i = 0; i < avisos.length; i++) {
      var box = avisos[i].closest('.frete-estimado');
      var input = box && box.querySelector('input[id^="frete-cep-"]');
      var cep = limpar(input && input.value) || lerCep();
      var r = regiaoDoCep(cep);
      var txt = r ? 'Frete grátis pro seu CEP (' + r.nome + ') em compras a partir de ' + reais(r.min) + '.'
                  : 'Frete grátis pra ' + FRETE_REGIOES.sudeste.nome + ' em compras a partir de ' + reais(FRETE_REGIOES.sudeste.min) + '.';
      if (avisos[i].textContent.trim() !== txt) avisos[i].textContent = txt;
    }
  }

  // Barra na página do produto: criada aqui, logo abaixo do botão de comprar.
  function criarBarraProduto() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('.js-frete-bar--produto')) return;
    if (document.querySelector('.frete-falta, .frete-estimado')) return; // a calculadora do produto já mostra a barra
    var form = document.querySelector('main form[action*="/cart/add"]');
    if (!form) return;
    var bar = document.createElement('div');
    bar.className = 'wt-free-shipping-bar js-frete-bar js-frete-bar--produto';
    bar.setAttribute('data-live', '1');
    bar.setAttribute('data-cart-total', '0');
    bar.innerHTML =
      '<p class="wt-free-shipping-bar__text js-frete-text"></p>' +
      '<div class="wt-progress-bar"><div class="wt-progress-bar__fill js-frete-fill" style="width:0%"></div></div>' +
      '<p class="frete-cep-linha"><span class="js-frete-regiao"></span>' +
      '<button type="button" class="frete-cep-link js-frete-cep-toggle">Calcular pelo meu CEP</button></p>' +
      '<div class="frete-cep-form js-frete-cep-form" hidden>' +
      '<input type="text" class="js-frete-cep-input" placeholder="00000-000" maxlength="9" inputmode="numeric" autocomplete="postal-code" aria-label="Seu CEP">' +
      '<button type="button" class="js-frete-cep-ok">OK</button></div>';
    form.parentNode.insertBefore(bar, form.nextSibling);
    var css = document.createElement('style');
    css.textContent =
      '.js-frete-bar--produto{margin:14px 0 4px;padding:12px 14px;border:1px solid #e3e3e3;border-radius:10px;background:#fafafa}' +
      '.js-frete-bar--produto .wt-free-shipping-bar__text{margin:0 0 8px;font-size:14px}' +
      '.js-frete-bar--produto .wt-progress-bar{height:6px;border-radius:6px;background:#e6e6e6;overflow:hidden}' +
      '.js-frete-bar--produto .wt-progress-bar__fill{height:100%;background:#0c7451;transition:width .3s}' +
      '.frete-cep-linha{margin:6px 0 0;font-size:12px;opacity:.85;display:flex;gap:6px;flex-wrap:wrap;align-items:center}' +
      '.frete-cep-link{background:none;border:0;padding:0;font:inherit;font-size:12px;text-decoration:underline;cursor:pointer;color:inherit}' +
      '.frete-cep-form{display:flex;gap:6px;margin-top:8px}.frete-cep-form[hidden]{display:none}' +
      '.frete-cep-form input{flex:1;min-width:0;padding:8px 10px;border:1px solid #d0d0d0;border-radius:6px;font:inherit;font-size:14px}' +
      '.frete-cep-form button{padding:8px 14px;border:0;border-radius:6px;background:#0c7451;color:#fff;font:inherit;font-size:13px;cursor:pointer}';
    document.head.appendChild(css);
  }

  // Barras "ao vivo" (fora do carrinho) leem o total atual do carrinho.
  var buscando = null;
  function atualizarTotalAoVivo() {
    var vivas = document.querySelectorAll('.js-frete-bar[data-live="1"]');
    if (!vivas.length) return;
    clearTimeout(buscando);
    buscando = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          for (var i = 0; i < vivas.length; i++) {
            if (vivas[i].getAttribute('data-cart-total') !== String(c.total_price)) {
              vivas[i].setAttribute('data-cart-total', String(c.total_price));
              atualizar(vivas[i]);
            }
          }
        })
        .catch(function () {});
    }, 300);
  }

  function atualizarTodas() {
    var bars = document.querySelectorAll('.js-frete-bar');
    for (var i = 0; i < bars.length; i++) atualizar(bars[i]);
    atualizarAvisosProduto();
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('button[id^="frete-btn-"]');
    if (!b) return;
    var box = b.closest('.frete-estimado');
    var input = box && box.querySelector('input[id^="frete-cep-"]');
    var cep = limpar(input && input.value);
    if (cep.length === 8) { salvarCep(cep); atualizarTodas(); }
  }, true);

  function confirmar(bar) {
    var input = bar.querySelector('.js-frete-cep-input');
    var cep = limpar(input && input.value);
    if (cep.length !== 8) { if (input) { input.focus(); input.style.borderColor = '#c0392b'; } return; }
    salvarCep(cep);
    var form = bar.querySelector('.js-frete-cep-form');
    if (form) form.hidden = true;
    atualizarTodas();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var toggle = t.closest('.js-frete-cep-toggle');
    if (toggle) {
      e.preventDefault();
      var bar = toggle.closest('.js-frete-bar');
      var form = bar && bar.querySelector('.js-frete-cep-form');
      if (form) {
        form.hidden = !form.hidden;
        var input = form.querySelector('.js-frete-cep-input');
        if (!form.hidden && input) { input.value = formatarCep(lerCep()); input.focus(); }
      }
      return;
    }
    var ok = t.closest('.js-frete-cep-ok');
    if (ok) { e.preventDefault(); confirmar(ok.closest('.js-frete-bar')); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.classList && e.target.classList.contains('js-frete-cep-input')) {
      e.preventDefault();
      confirmar(e.target.closest('.js-frete-bar'));
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('js-frete-cep-input')) {
      e.target.style.borderColor = '';
      var v = limpar(e.target.value);
      e.target.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
    }
  });

  // O carrinho é redesenhado pelo tema a cada alteração: recalcula sempre que algo muda.
  var agendado = false;
  var obs = new MutationObserver(function (muts) {
    if (agendado) return;
    // ignora mudanças feitas dentro das próprias barras
    var relevante = false, carrinho = false;
    for (var i = 0; i < muts.length; i++) {
      var alvo = muts[i].target;
      if (!alvo.closest || alvo.closest('.js-frete-bar')) continue;
      relevante = true;
      if (alvo.closest('cart-drawer, #cart-icon-bubble, .cart-count-bubble')) { carrinho = true; break; }
    }
    if (!relevante) return;
    agendado = true;
    requestAnimationFrame(function () { agendado = false; atualizarTodas(); if (carrinho) atualizarTotalAoVivo(); });
  });

  function iniciar() {
    criarBarraProduto();
    atualizarTodas();
    atualizarTotalAoVivo();
    obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();

  window.ColheitaFrete = {
    salvarCep: function (cep) { salvarCep(cep); atualizarTodas(); },
    aviso: function (cep) {
      var r = regiaoDoCep(cep) || FRETE_REGIOES.sudeste;
      return 'Frete grátis pro seu CEP (' + r.nome + ') em compras a partir de ' + reais(r.min) + '.';
    }
  };
})();

/* Oferta de balcão no carrinho (snippets/oferta-balcao.liquid): adiciona o produto sugerido num clique. */
(function () {
  if (window.__ofertaBalcao) return;
  window.__ofertaBalcao = true;
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.js-oferta-balcao');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        if (/\/cart\/?$/.test(window.location.pathname)) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Tentar de novo';
      });
  });
})();
